/**
 * Personeelszaken (WALLIYO-0131), in het Nederlands. A faithful translation of hr.en.ts,
 * which is the source text.
 */
export const hrNl = {
  "hr.tabs.aria": "Personeelszaken",
  "hr.tab.directory": "Smoelenboek",
  "hr.tab.recruiting": "Werving",
  "hr.tab.employees": "Medewerkers",
  "hr.tab.learning": "Opleiding",
  "hr.subTabs.aria": "Medewerkers",
  "hr.sub.records": "Dossiers",
  "hr.sub.joining": "Indiensttreding",
  "hr.sub.timeOff": "Vrije dagen van allen",
  "hr.sub.performance": "Prestatie",
  "hr.sub.payroll": "Loon",
  "hr.sub.reviews": "Controles",
  "hr.sub.leaving": "Uitdiensttreding",
  "hr.locked": "Dit tabblad is voor personeelszaken.",
  "hr.notBuilt": "Nog niet gebouwd.",
  "hr.notBuiltHelp": "Dit tabblad is ontworpen en wacht op zijn endpoint. Er gaat niets verloren.",
  "directory.title": "Smoelenboek",
  "directory.sub": "Iedereen kan iedereen opzoeken.",
  "directory.search": "Iemand vinden",
  "directory.searchHelp": "Een naam, of het nummer op hun pas.",
  "directory.searchPlaceholder": "Naam of UUID",
  "directory.go": "Zoeken",
  "directory.clear": "Iedereen tonen",
  "directory.loading": "Smoelenboek wordt gelezen…",
  "directory.failed": "Het smoelenboek kon niet worden gelezen.",
  "directory.retry": "Opnieuw proberen",
  "directory.none": "Niemand hier komt overeen met “{query}”.",
  "directory.empty": "Er staat nog niemand in.",
  "directory.count": "{shown} van {total}",
  "directory.more": "Meer treffers dan getoond. Verfijn de zoekopdracht.",
  "directory.colName": "Naam",
  "directory.colRoles": "Rol",
  "directory.colTeams": "Teams",
  "directory.colManager": "Leidinggevende",
  "directory.open": "Openen",
  "directory.noRole": "Nog geen rol",
  "directory.noTeam": "Nog geen team",
  "directory.noManager": "Geen leidinggevende",
  "directory.leads": "leidt het",
  "directory.invited": "Uitgenodigd",
  "directory.back": "Terug naar het smoelenboek",
  "directory.identity": "Wie ze zijn",
  "directory.uuid": "UUID",
  "directory.uuidHelp": "Het nummer op hun pas. Het verandert nooit.",
  "directory.email": "E-mail",
  "directory.managerOn": "{name}, {team}",
  "directory.teammates": "Iedereen in hun teams",
  "directory.whereTheySit": "Waar deze persoon zit",
  "directory.emailThem": "Een e-mail sturen",
  "directory.teammatesNone": "Ze zijn de enige in hun teams.",
  "directory.personFailed": "Deze persoon kon niet worden gelezen.",
  "directory.viewOnly": "Het smoelenboek toont alleen de structuur. Wat iemand mag staat bij Medewerkers.",
  "hr.loading": "Wordt gelezen…",
  "hr.failed": "Dat kon niet worden gelezen.",
  "hr.retry": "Opnieuw proberen",
  "joining.invite": "Iemand uitnodigen",
  "joining.invited.title": "Openstaande uitnodigingen",
  "joining.invited.help": "Ze hebben al een UUID en kunnen pas inloggen zodra ze een wachtwoord instellen.",
  "joining.invited.none": "Niemand wacht om te beginnen.",
  "joining.arrived.title": "Onlangs begonnen",
  "joining.arrived.help": "Iedereen die de laatste 30 dagen is begonnen.",
  "joining.arrived.none": "Er is niemand begonnen in de laatste 30 dagen.",
  "joining.col.name": "Naam",
  "joining.col.roles": "Rol",
  "joining.col.sent": "Uitgenodigd op",
  "joining.col.waiting": "Wacht al",
  "joining.col.joined": "Begonnen op",
  "joining.today": "Vandaag",
  "joining.waiting": "{days} dagen",
  "joining.stale": "Even achteraan gaan",

  // ── Leaving ──
  "leaving.who": "Wie vertrekt",
  "leaving.whoHelp": "Iedereen die er nog is, en iedereen die al weg is.",
  "leaving.pick": "Kies iemand",
  "leaving.alreadyLeft": "al weg",
  "leaving.nobody": "Kies iemand om te zien wat een vertrek zou achterlaten.",
  "leaving.gone": "{name} is al weg. Dit zijn de losse eindjes.",
  "leaving.noReason": "Geen reden opgegeven",
  "leaving.teams.title": "Teams die ze leiden",
  "leaving.teams.help":
    "In een team zonder leiding keurt niemand verlof goed, beoordeelt niemand iemand en bevestigt niemand toegang — dat is hetzelfde feit.",
  "leaving.teams.none": "Ze leiden geen team.",
  "leaving.teams.col.team": "Team",
  "leaving.teams.col.others": "Anderen erin",
  "leaving.teams.col.after": "Na hun vertrek",
  "leaving.team.others": "{count} anderen",
  "leaving.team.noLead": "Niemand zou het leiden",
  "leaving.team.covered": "Iemand anders leidt het",
  "leaving.team.handOver": "Overdragen",
  "leaving.grants.title": "Op naam toegekend",
  "leaving.grants.help":
    "Een rol intrekken raakt dit nooit. Een toekenning zonder einddatum is hoe iemand die weg is nog een recht houdt.",
  "leaving.grants.none": "Er is niets op naam toegekend.",
  "leaving.grants.col.what": "Wat",
  "leaving.grants.col.why": "Waarom",
  "leaving.grants.col.ends": "Eindigt",
  "leaving.grant.forever": "Eindigt nooit",
  "leaving.grant.until": "Tot",
  "leaving.grants.revoke": "Deze intrekken",
  "leaving.last.title": "De laatste stap",
  "leaving.last.help":
    "Deactiveren beëindigt hun {sessions} open sessies en houdt ze buiten. Niets van wat ze deden wordt verwijderd — het auditlogboek noemt ze voorgoed — en ze blijven vermeld bij hun teams, zodat niemand stilletjes een persoon tekortkomt.",
  "leaving.last.deactivate": "Deactiveren",
  "leaving.last.seeThem": "In het smoelenboek bekijken",

  // ── Records ──
  "records.find": "Zoeken",
  "records.findPlaceholder": "Naam of e-mail",
  "records.team": "Team",
  "records.role": "Rol",
  "records.any": "Alle",
  "records.dueReview": "{count} toegangen te herzien",
  "records.accessDueReview": "toegang te herzien",
  "records.none": "Niemand komt overeen.",
  "records.neverSeen": "Nooit ingelogd",
  "records.col.person": "Persoon",
  "records.col.role": "Rol",
  "records.col.teams": "Teams",
  "records.col.joined": "Begonnen",
  "records.col.lastSeen": "Laatst gezien",

  // ── Time off ──
  "timeOff.ask": "Verlof aanvragen",
  "timeOff.approve": "Goedkeuren",
  "timeOff.refuse": "Afwijzen",
  "timeOff.days": "{days} dagen",
  "timeOff.decidedBy": "Beslist door {name}",
  "timeOff.col.who": "Wie",
  "timeOff.col.kind": "Soort",
  "timeOff.col.when": "Wanneer",
  "timeOff.col.days": "Dagen",
  "timeOff.col.status": "Status",
  "timeOff.kind.annual": "Jaarlijks verlof",
  "timeOff.kind.sick": "Ziekteverlof",
  "timeOff.kind.unpaid": "Onbetaald",
  "timeOff.kind.parental": "Ouderschapsverlof",
  "timeOff.kind.other": "Anders",
  "timeOff.status.pending": "Wacht",
  "timeOff.status.approved": "Goedgekeurd",
  "timeOff.status.refused": "Afgewezen",
  "timeOff.status.withdrawn": "Ingetrokken",
  "timeOff.balance.title": "Uw saldo",
  "timeOff.balance.none": "Uw recht is nog niet vastgelegd. Personeelszaken doet dat op uw dienstverband.",
  "timeOff.balance.allowance": "Recht",
  "timeOff.balance.taken": "Opgenomen",
  "timeOff.balance.pending": "Aangevraagd",
  "timeOff.balance.pendingHelp": "Niet opgenomen, maar ook niet vrij.",
  "timeOff.balance.left": "Over",
  "timeOff.toDecide.title": "Wacht op u",
  "timeOff.toDecide.help": "U leidt hun team, dus u beslist. Bij personeelszaken zitten is niet hetzelfde.",
  "timeOff.mine.title": "Uw aanvragen",
  "timeOff.mine.none": "U heeft geen verlof aangevraagd.",
  "timeOff.away.title": "Vandaag afwezig",
  "timeOff.away.none": "Vandaag is niemand afwezig.",
  "timeOff.everybody.title": "Iedereen",
  "timeOff.everybody.help": "U ziet dit omdat u bij personeelszaken zit. Beslissen doet hun teamleider.",
  "timeOff.form.title": "Verlof aanvragen",
  "timeOff.form.kind": "Soort",
  "timeOff.form.from": "Eerste dag",
  "timeOff.form.to": "Laatste dag",
  "timeOff.form.days": "Dagen",
  "timeOff.form.daysHelp": "Hoeveel werkdagen dit beslaat.",
  "timeOff.form.reason": "Reden",
  "timeOff.form.submit": "Aanvraag versturen",
  "timeOff.decide.title": "Deze aanvraag beslissen",
  "timeOff.decide.approveNote": "Zeg waarom u goedkeurt",
  "timeOff.decide.refuseNote": "Zeg waarom u afwijst",
  "timeOff.decide.submit": "Beslissing vastleggen",
  "timeOff.done": "{days} dagen aangevraagd. Uw teamleider beslist erover.",
  "timeOff.approvedDone": "Het verlof van {name} is goedgekeurd.",
  "timeOff.refusedDone": "De aanvraag van {name} is afgewezen.",

  // ── Reviews ──
  "reviews.grants.title": "Nu de moeite waard",
  "reviews.grants.help":
    "Een toekenning met einddatum trekt zichzelf in. Dit zijn die zonder, en die van mensen die er niet meer zijn.",
  "reviews.grants.none": "Er is niets op naam zonder einddatum.",
  "reviews.leads.title": "Leidinggevenden die moeten kijken",
  "reviews.leads.help": "Wie hun team leidt weten we al — niemand hoeft te horen wie wie beoordeelt.",
  "reviews.leads.none": "Niemands mensen hebben iets op naam.",
  "reviews.col.who": "Wie",
  "reviews.col.what": "Wat",
  "reviews.col.why": "Waarom",
  "reviews.col.concern": "Zorg",
  "reviews.col.lead": "Leidinggevende",
  "reviews.col.team": "Team",
  "reviews.col.people": "Personen",
  "reviews.col.neverEnding": "Zonder einde",
  "reviews.concern.holderLeft": "Is vertrokken",
  "reviews.concern.neverEnds": "Eindigt nooit",
  "reviews.concern.neverUsed": "Nooit gebruikt",
  "reviews.changedAt": "Laatst gewijzigd op {when}",
  "reviews.open": "Hun rechten openen",

  // ── Payroll ──
  "payroll.month": "Maand",
  "payroll.open": "Een maand openen",
  "payroll.close": "Maand afsluiten",
  "payroll.notOpen": "Deze maand is nog niet geopend.",
  "payroll.closedOn": "Afgesloten op {when} door {name}",
  "payroll.hold": "Blokkeren",
  "payroll.release": "Vrijgeven",
  "payroll.lines.title": "Wat iedereen krijgt",
  "payroll.lines.help":
    "Opgesteld uit de dienstverbanden zoals ze waren toen de maand werd geopend. Een latere verhoging verandert hier niets.",
  "payroll.col.person": "Persoon",
  "payroll.col.gross": "Bruto",
  "payroll.col.contributions": "Bijdragen",
  "payroll.col.net": "Netto",
  "payroll.col.status": "Status",
  "payroll.status.ready": "Klaar",
  "payroll.status.held": "Geblokkeerd",
  "payroll.status.paid": "Betaald",
  "payroll.total.people": "Personen",
  "payroll.total.gross": "Bruto",
  "payroll.total.contributions": "Bijdragen",
  "payroll.total.net": "Netto",
  "payroll.missing.title": "Van deze mensen weet niemand wat ze verdienen",
  "payroll.missing.help":
    "Hun dienstverband vermeldt geen bruto, dus een run kan hen niet betalen. Vul het in vóór de volgende maand.",
  "payroll.openForm.title": "Een maand openen",
  "payroll.openForm.month": "Maand",
  "payroll.openForm.help":
    "Elk dienstverband met een bruto krijgt een regel. Bijdragen beginnen op nul: wat wordt ingehouden hangt af van waar iemand is, en dat is niet aan dit scherm om te raden.",
  "payroll.openForm.submit": "Openen",
  "payroll.holdForm.title": "Deze regel wijzigen",
  "payroll.holdForm.hold": "Tegenhouden",
  "payroll.holdForm.release": "Vrijgeven",
  "payroll.closeForm.title": "Maand afsluiten",
  "payroll.closeForm.help":
    "Elke klaarstaande regel wordt betaald. Een geblokkeerde blijft geblokkeerd, daar diende het blokkeren voor.",
  "payroll.closeForm.submit": "Afsluiten",
  "payroll.opened": "{month} is geopend, met {count} regels.",
  "payroll.held": "De regel van {name} is geblokkeerd.",
  "payroll.released": "De regel van {name} wordt betaald.",
  "payroll.closed": "De maand is afgesloten.",

  // ── Performance ──
  "performance.cycle": "Ronde",
  "performance.openCycle": "Een ronde openen",
  "performance.noCycle": "Er is nog geen ronde geopend.",
  "performance.runs": "Loopt van {from} tot {to}",
  "performance.write": "Schrijven",
  "performance.keepWriting": "Verder schrijven",
  "performance.col.who": "Wie",
  "performance.col.reviewer": "Beoordelaar",
  "performance.col.status": "Status",
  "performance.col.outcome": "Hoe het ging",
  "performance.status.notStarted": "Niet begonnen",
  "performance.status.inProgress": "Wordt geschreven",
  "performance.status.submitted": "Ingediend",
  "performance.status.signedOff": "Afgetekend",
  "performance.gap.noTeam": "In geen enkel team",
  "performance.gap.noLead": "Team heeft geen leider",
  "performance.gap.leadsOwn": "Leidt het eigen team",
  "performance.toWrite.title": "Wacht op u",
  "performance.toWrite.help": "U leidt hun team, dus u schrijft deze.",
  "performance.mine.title": "Uw beoordeling",
  "performance.mine.none": "U heeft deze ronde geen beoordeling.",
  "performance.everybody.title": "Iedereen",
  "performance.everybody.help": "U ziet dit omdat u bij personeelszaken zit. Schrijven doet de beoordelaar.",
  "performance.everybody.gaps":
    "{count} hiervan heeft niemand om ze te schrijven. Dat zegt iets over de organisatie, niet over deze ronde.",
  "performance.form.title": "Een ronde openen",
  "performance.form.name": "Naam",
  "performance.form.opens": "Eerste dag",
  "performance.form.closes": "Laatste dag",
  "performance.form.submit": "Openen",
  "performance.writeForm.title": "De beoordeling schrijven",
  "performance.writeForm.outcome": "Hoe het ging",
  "performance.writeForm.outcomeHelp": "Een woord dat u kiest, geen cijfer van vijf.",
  "performance.writeForm.note": "Wat er gebeurd is",
  "performance.writeForm.save": "Bewaren voor later",
  "performance.writeForm.send": "Indienen",
  "performance.opened": "{name} is geopend, met {count} beoordelingen.",
  "performance.saved": "Bewaard. Niemand ziet het tot u het indient.",
  "performance.sent": "Ingediend. {name} kan het nu zien.",

  // ── Recruiting and Learning ──
  "recruiting.openJob": "Een vacature openen",
  "recruiting.editJob": "Wijzigen",
  "recruiting.addCandidate": "Iemand toevoegen",
  "recruiting.move": "Verder brengen",
  "recruiting.none": "Er is nog geen vacature geopend.",
  "recruiting.noTeam": "Geen team",
  "recruiting.noCandidates": "Er heeft nog niemand gesolliciteerd.",
  "recruiting.liveCandidates": "{count} in de race",
  "recruiting.col.candidate": "Kandidaat",
  "recruiting.col.reach": "Hoe te bereiken",
  "recruiting.col.stage": "Fase",
  "recruiting.col.applied": "Gesolliciteerd",
  "recruiting.stage.applied": "Gesolliciteerd",
  "recruiting.stage.screening": "Voorselectie",
  "recruiting.stage.interview": "Gesprek",
  "recruiting.stage.offer": "Aanbod uit",
  "recruiting.stage.hired": "Aangenomen",
  "recruiting.stage.declined": "Afgewezen",
  "recruiting.stage.withdrawn": "Teruggetrokken",
  "recruiting.status.open": "Open",
  "recruiting.status.onHold": "Gepauzeerd",
  "recruiting.status.filled": "Vervuld",
  "recruiting.status.closed": "Gesloten",
  "recruiting.jobForm.title": "Een vacature openen",
  "recruiting.jobForm.name": "Titel",
  "recruiting.jobForm.team": "Team",
  "recruiting.jobForm.noTeam": "Nog geen team",
  "recruiting.jobForm.description": "Waar het om gaat",
  "recruiting.jobForm.status": "Status",
  "recruiting.jobForm.submit": "Openen",
  "recruiting.candidateForm.title": "Iemand toevoegen",
  "recruiting.candidateForm.name": "Naam",
  "recruiting.candidateForm.phone": "Telefoon",
  "recruiting.candidateForm.email": "E-mail",
  "recruiting.candidateForm.note": "Wat goed is om te weten",
  "recruiting.candidateForm.submit": "Toevoegen",
  "recruiting.moveForm.title": "Verder brengen",
  "recruiting.moveForm.stage": "Fase",
  "recruiting.moveForm.hired":
    "Iemand als aangenomen markeren legt vast dat het gebeurde. Uitnodigen gaat via Indiensttreding, waar dat al bestaat.",
  "recruiting.moveForm.submit": "Verder brengen",
  "recruiting.jobOpened": "{title} is open.",
  "recruiting.jobEdited": "{title} is bijgewerkt.",
  "recruiting.candidateAdded": "{name} staat op de lijst.",
  "recruiting.candidateMoved": "{name} zit nu in {stage}.",
  "learning.addCourse": "Een cursus toevoegen",
  "learning.enrol": "Inschrijven",
  "learning.continue": "Doorgaan",
  "learning.finish": "Afronden",
  "learning.alreadyEnrolled": "Ingeschreven",
  "learning.requiredBy": "Vereist voor {permission} — af te ronden vóór de toekenning, niet erna.",
  "learning.requiredOfAll": "Voor iedereen verplicht",
  "learning.anybody": "Voor iedereen open",
  "learning.minutes": "{minutes} min",
  "learning.enrolled": "{count} ingeschreven",
  "learning.hrOnly": "Alleen personeelszaken",
  "learning.mine.title": "Voor u verplicht",
  "learning.mine.help": "Een cursus aan een recht moet af zijn voordat het recht wordt toegekend.",
  "learning.mine.none": "Er is op dit moment niets voor u verplicht.",
  "learning.catalogue.title": "Catalogus",
  "learning.catalogue.help":
    "Voor iedereen open. Inschrijven vraagt niemands toestemming — de toekenning achter de cursus wel.",
  "learning.byTeam.title": "In het hele bedrijf",
  "learning.byTeam.help": "Wie de verplichte cursussen nog moet doen. Achteraan gaat de teamleider.",
  "learning.col.course": "Cursus",
  "learning.col.status": "Status",
  "learning.col.progress": "Voortgang",
  "learning.col.team": "Team",
  "learning.col.people": "Personen",
  "learning.col.done": "Klaar",
  "learning.status.enrolled": "Ingeschreven",
  "learning.status.inProgress": "Bezig",
  "learning.status.done": "Afgerond",
  "learning.courseForm.title": "Een cursus toevoegen",
  "learning.courseForm.name": "Titel",
  "learning.courseForm.audience": "Voor wie",
  "learning.courseForm.minutes": "Hoe lang het duurt, in minuten",
  "learning.courseForm.required": "Vereist voor een recht",
  "learning.courseForm.requiredHelp": "De setting-id van het recht waarvoor deze cursus een voorwaarde is.",
  "learning.courseForm.everybody": "Voor iedereen verplicht",
  "learning.courseForm.submit": "Toevoegen",
  "learning.courseAdded": "{title} staat in de catalogus.",
  "learning.enrolledDone": "Ingeschreven voor {title}.",
  "learning.finished": "{title} is afgerond.",

  // ── Alerts and refusals ──
  "alert.dismiss": "Sluiten",
  "error.reason.permission_not_held":
    "Uw rol opent dit scherm, maar niet deze actie. Vraag iemand die het kan toekennen.",
  "error.reason.not_found": "Dit bestaat niet meer. Herlaad en probeer opnieuw.",
  "error.reason.no_reason": "Zeg kort waarom.",
  "error.reason.name_taken": "Die naam is al bezet.",
  "error.reason.team_closed": "Dit is gesloten. Open het weer voordat u iemand toevoegt.",
  "error.reason.staff_deactivated": "Deze persoon is vertrokken en kan niet worden toegevoegd.",
  "error.reason.lead_must_be_member": "Je leidt alleen een team waar je in zit.",
  "error.reason.duplicate_change": "Dezelfde persoon staat er twee keer in. Stuur ze één keer.",
  "error.reason.own_request": "U kunt niet over uw eigen verlof beslissen.",
  "error.reason.not_their_lead": "Alleen wie hun team leidt beslist dit. Bij personeelszaken zitten is niet hetzelfde.",
  "error.reason.already_decided": "Hier is al over beslist. Herlaad om te zien hoe.",
  "error.reason.backwards": "De laatste dag ligt voor de eerste.",
  "error.reason.too_long": "Dat is langer dan één aanvraag kan beslaan.",
  "error.reason.month_open": "Die maand is al geopend.",
  "error.reason.already_paid": "Deze regel is betaald. Een afgesloten maand is wat betaald is.",
  "error.reason.already_closed": "Deze maand is al afgesloten.",
  "error.reason.nobody_payable": "Op geen enkel dienstverband staat een bruto.",
  "error.reason.invalid_month": "Geef de maand als JJJJ-MM.",
  "error.reason.own_review": "U kunt uw eigen beoordeling niet schrijven.",
  "error.reason.not_the_reviewer": "Iemand anders is hierom gevraagd.",
  "error.reason.signed_off": "Deze beoordeling is afgetekend.",
  "error.reason.no_outcome": "Zeg hoe het ging voordat u indient.",
  "error.reason.job_closed": "Deze vacature is gesloten. Open hem weer voordat u iemand toevoegt.",
  "error.reason.candidate_out": "Deze persoon is niet meer in de race. Voeg ze opnieuw toe als ze terugkomen.",
  "error.reason.title_taken": "Die titel is al bezet.",
  "error.reason.course_retired": "Deze cursus wordt niet meer gegeven.",
  "error.reason.invalid_progress": "Voortgang is een heel percentage, van 0 tot 100.",

  // ── Roles: what a role covers ──
  "roles.covers.everything": "Alles",
  "roles.covers.features": "{count} functies",
  "roles.covers.permissions": "{count} rechten",
  "roles.covers.critical": "{count} kritiek",
  "roles.covers.high": "{count} hoog",
  "roles.covers.seeAll": "Alle {count} bekijken",
  "roles.covers.permissionsHeading": "Rechten",

  // ── Roles, redesigned ──
  "roles.band.critical": "rollen kunnen bepalen wat iedereen mag",
  "roles.band.people": "personen hebben er een",
  "roles.band.total": "rollen in totaal",
  "roles.band.unheld": "heeft niemand",
  "roles.reach.critical": "Kritiek",
  "roles.reach.high": "Hoog",
  "roles.reach.low": "Laag",
  "roles.rail.people": "{count} personen",
  "roles.rail.unheld": "niemand heeft hem",
  "roles.noDescription": "Geen omschrijving",
  "roles.figure.people": "Personen",
  "roles.figure.features": "Functies",
  "roles.figure.permissions": "Rechten",
  "roles.figure.critical": "Kritiek",
  "roles.block.holders": "Wie hem heeft",
  "roles.block.holdersHelp": "Wie deze rol krijgt, krijgt alles hieronder.",
  "roles.block.holdersNone": "Niemand heeft deze rol.",
  "roles.block.give": "Aan iemand geven",
  "roles.block.take": "Afnemen",
  "roles.block.grants": "Wat hij geeft",
  "roles.block.grantsHelp": "Hoe ver hij reikt, per gebied.",
  "roles.block.criticalWarning": "Wie deze rol heeft, kan bepalen wat ieder ander mag.",
  "roles.block.change": "Wijzigen wat hij geeft",
  "roles.block.opens": "Wat hij opent",
  "roles.block.opensHelp": "Berekend uit de functies hierboven, nooit opgeslagen — het menu vraagt dezelfde functie.",
  "roles.block.opensNone": "Hij opent op zichzelf geen scherm.",
  "roles.block.compare": "Vergeleken met",
  "roles.block.compareWith": "Vergelijken met",
  "roles.compare.only": "{count} alleen hier",
  "roles.compare.theirs": "{count} alleen daar",
  "roles.compare.shared": "{count} gedeeld",
  "roles.give.title": "Deze rol aan iemand geven",
  "roles.give.who": "Wie",
  "roles.give.submit": "Geven",
  "roles.give.done": "{name} heeft nu {role}.",
  "roles.take.title": "Deze rol afnemen",
  "roles.take.body": "Alle andere rollen blijven.",
  "roles.take.submit": "Afnemen",
  "roles.take.done": "{name} heeft {role} niet meer.",
  "roles.holdersUnknown": "Kon niet worden gelezen",
  "roles.compare.same": "Ze geven precies dezelfde functies.",
  "roles.notice.critical": "{roles} hiervan kunnen bepalen wat iedereen mag — {people} personen hebben er een.",
  "roles.notice.criticalOnly": "{roles} hiervan kunnen bepalen wat iedereen mag.",
  "roles.notice.unheld": "{count} heeft niemand.",

  // ── Actions, by person ──
  "actions.find": "Iemand zoeken",
  "actions.matches": "Wie bedoelde u?",
  "actions.findPlaceholder": "Naam of UUID",
  "actions.nobody": "Zoek iemand om te zien wat hij mag.",
  "actions.noRoles": "Geen rol",
  "actions.col.on": "Aan",
  "actions.col.source": "Bron",
  "actions.col.reason": "Reden",
  "actions.mustAsk": "moet vragen boven {limit}",
  "actions.clear": "Wissen",
  "actions.until": "tot {when}",
  "actions.onlyOverrides":
    "Alleen een uitzondering staat op deze persoon, dus de enige die dit scherm kan weghalen. Al het andere komt uit een rol of uit hoe de actie wordt geleverd — wijzig die waar ze leven.",
  "actions.blocked.permission": "Ze hebben de functie, niet het recht dat deze actie vereist.",
  "actions.locked.noFeature": "Voor iedereen open: er zit geen schakelaar achter.",
  "actions.view.catalogue": "De catalogus",
  "actions.view.person": "Per persoon",
  "actions.notWiredYet": "Inschakelen is nog niet aangesloten. Gebruik voorlopig Functies en Rechten.",
  "actions.view.role": "Per rol",
  "actions.pickRole": "Rol",

  // ── Switching an action ──
  "actions.switch.onTitle": "Inschakelen",
  "actions.switch.offTitle": "Uitschakelen",
  "actions.switch.clearTitle": "Wissen",
  "actions.switch.submit": "Inschakelen",
  "actions.switch.writes": "Dit schrijft de functie erachter: {feature}.",
  "actions.switch.alsoMoves": "Die functie opent ook {count} andere acties, die meegaan: {actions}.",
  "actions.switch.permissionToo": "Het recht dat deze actie vereist ontbreekt nog. Ken dat toe bij Rechten.",
  "actions.switch.switchedOn": "{action} staat aan voor {who}.",
  "actions.switch.switchedOff": "{action} staat uit voor {who}.",
  "actions.switch.cleared": "{action} valt terug op wat wordt geërfd.",
  "actions.pending": "nog niet opgeslagen",
  "actions.saved": "{count} schakelaars opgeslagen.",
} as const;
